import { render, staticRenderFns } from "./ViewersSection.vue?vue&type=template&id=4553a72a&scoped=true"
import script from "./ViewersSection.vue?vue&type=script&lang=js"
export * from "./ViewersSection.vue?vue&type=script&lang=js"
import style0 from "./ViewersSection.vue?vue&type=style&index=0&id=4553a72a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4553a72a",
  null
  
)

export default component.exports